import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('store_consumption_location')
export class StoreConsumptionLocations {
    @PrimaryGeneratedColumn('increment', {
        name: 'store_consumption__loc_id',
    })
    storeConsumptionLocId: number;

    @Column('int',{
        name:'location_id',
        nullable:false
    })
    locationId : number

    @Column('int',{
        name:'quantity',
        nullable:false
    })
    quatity : number

    @Column('int',{
        name:'store_consumption_id',
        nullable:false
    })
    storeConsumptionId : number
}